export const PreCertPaths = {
  BaseName: "/precert",
  ErrorPage: "error",
  NotFound: "notfound",
  UnauthorizedPage: "unauthorized"
}

export const GetFullPathName = (path: string) => `${PreCertPaths.BaseName}/${path}`;

export const IsErrorPage = () => window.location.pathname == GetFullPathName(PreCertPaths.ErrorPage) ||  window.location.pathname == GetFullPathName(PreCertPaths.UnauthorizedPage);